import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Router } from "@angular/router";

import { ServicoOfflinePerguntaOpcao } from "../../model";

import { GERENCIAMENTO, ITENSPORPAGINA } from "../../app.config";

@Injectable()
export class ServicoOfflinePerguntaOpcaoService {
    constructor(private http: HttpClient) {}

    buscarPorParametro(param: string, pagina: Number, idpergunta: number): Observable<any> {
        if (param.length > 0) {
            return this.http.get<any>(
                `${GERENCIAMENTO}/api/offlineservicoperguntaopcao/list/${param.trim()}?Pagina=${pagina}&ItensPorPagina=${ITENSPORPAGINA}&IdPergunta=${idpergunta}`
            );
        } else {
            return this.http.get<any>(
                `${GERENCIAMENTO}/api/offlineservicoperguntaopcao?Pagina=${pagina}&ItensPorPagina=${ITENSPORPAGINA}&IdPergunta=${idpergunta}`
            );
        }
    }

    buscarPorId(id: number): Observable<any> {
        return this.http.get<any>(
            `${GERENCIAMENTO}/api/offlineservicoperguntaopcao/${id}?Pagina=1&ItensPorPagina=${ITENSPORPAGINA}`
        );
    }

    remover(id: Number): Observable<any> {
        return this.http.delete<any>(`${GERENCIAMENTO}/api/offlineservicoperguntaopcao/${id}`);
    }

    salvar(servicoofflineperguntaopcao: ServicoOfflinePerguntaOpcao): Observable<any> {
        if (servicoofflineperguntaopcao.Id > 0) {
            return this.http.put<any>(
                `${GERENCIAMENTO}/api/offlineservicoperguntaopcao/${servicoofflineperguntaopcao.Id}`,
                servicoofflineperguntaopcao
            );
        } else {
            return this.http.post<any>(
                `${GERENCIAMENTO}/api/offlineservicoperguntaopcao/`,
                servicoofflineperguntaopcao
            );
        }
    }
}
